module.exports = __webpack_public_path__ + "872ff7a1f63cedd95eebc78769c64851.MP3";